// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--aveRk","EventWidget":"EventWidget--lfmki","Analysis":"Analysis--2uuNJ"};